import { can } from '@kronos/domain'
import type { Role } from '@kronos/domain'
import { DesignTree } from './DesignTree'
import { EmptyState, PageHeader, Panel } from './primitives'

/**
 * Design — what the things we build are made of, drawn as one tree.
 *
 * Nothing in this repository knows that an arm has seven joints, that an
 * actuator counts revolutions, or that a wheel module exists. Those are rows
 * an engineer creates, because the mechanical engineers decide how the robot
 * breaks into swap units and that answer will change more than once before
 * there are 206 of them.
 *
 * Items themselves are listed, added and edited in one place, Inventory
 * (`ItemEditor`) — this page used to keep a second list of the same rows,
 * and two lists of one thing is one too many. Editing from here is the tree
 * inspector's Edit button, which opens that same editor.
 */
export function AdminView({ roles }: { roles: readonly Role[] }): JSX.Element {
  if (!can(roles, 'edit_catalog')) {
    return (
      <div className="page">
        <PageHeader title="Design" />
        <Panel>
          <EmptyState title="Engineers only">What things are made of is decided by engineers.</EmptyState>
        </Panel>
      </div>
    )
  }

  return (
    <div className="page">
      <PageHeader title="Design" subtitle="How each thing we build is made — tap a part to see it or edit it." />
      <DesignTree />
    </div>
  )
}
